/* SEKACAMP global UI - accordions, before/after compare, recently-viewed. Editor-safe (re-inits on shopify:section:load). */
(function () {
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function attr(s) { return esc(s).replace(/"/g, '&quot;'); }

  /* ---- accordions (delegated, global) ---- */
  document.addEventListener('click', function (e) {
    var h = e.target.closest('[data-acc-head]'); if (!h) return;
    var item = h.closest('[data-acc]'); if (!item) return;
    var open = item.classList.toggle('open');
    h.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  function initAcc(scope) {
    (scope || document).querySelectorAll('[data-acc-head]').forEach(function (h) {
      var it = h.closest('[data-acc]'); if (it) h.setAttribute('aria-expanded', it.classList.contains('open') ? 'true' : 'false');
    });
  }

  /* ---- before / after compare slider ---- */
  function initCompare(scope) {
    (scope || document).querySelectorAll('[data-compare]').forEach(function (c) {
      if (c.__cmp) return; c.__cmp = true;
      var before = c.querySelector('[data-cmp-before]'), handle = c.querySelector('[data-cmp-handle]');
      if (!before || !handle) return;
      var set = function (p) { p = Math.max(0, Math.min(100, p)); before.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)'; handle.style.left = p + '%'; handle.setAttribute('aria-valuenow', Math.round(p)); };
      set(50);
      var drag = false, move = function (x) { var r = c.getBoundingClientRect(); set((x - r.left) / r.width * 100); };
      c.addEventListener('mousedown', function (e) { drag = true; move(e.clientX); e.preventDefault(); });
      // window listeners only track drags that started on this element AND
      // bail once it leaves the DOM (theme-editor re-renders replace sections)
      var onMove = function (e) { if (!document.contains(c)) { window.removeEventListener('mousemove', onMove); window.removeEventListener('mouseup', onUp); return; } if (drag) move(e.clientX); };
      var onUp = function () { drag = false; };
      window.addEventListener('mousemove', onMove);
      window.addEventListener('mouseup', onUp);
      c.addEventListener('touchstart', function (e) { drag = true; move(e.touches[0].clientX); }, { passive: true });
      c.addEventListener('touchmove', function (e) { if (drag) move(e.touches[0].clientX); }, { passive: true });
      c.addEventListener('touchend', function () { drag = false; });
      handle.addEventListener('keydown', function (e) { var v = parseFloat(handle.getAttribute('aria-valuenow')) || 50; if (e.key === 'ArrowLeft') { set(v - 4); e.preventDefault(); } else if (e.key === 'ArrowRight') { set(v + 4); e.preventDefault(); } });
    });
  }

  /* ---- recently viewed (localStorage) ---- */
  var locale = document.documentElement.lang || 'default';
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'default';
  var RKEY = 'seka_recent:' + locale + ':' + currency;
  function readRecent() { try { var list = JSON.parse(localStorage.getItem(RKEY)); return Array.isArray(list) ? list : []; } catch (e) { return []; } }
  function curHandle() { var el = document.querySelector('[data-seka-product]'); if (!el) return ''; try { return (JSON.parse(el.textContent) || {}).handle || ''; } catch (e) { return ''; } }
  function storeCurrent() {
    var el = document.querySelector('[data-seka-product]'); if (!el) return;
    var p; try { p = JSON.parse(el.textContent); } catch (e) { return; } if (!p || !p.handle) return;
    var list = readRecent().filter(function (x) { return x && x.handle !== p.handle; });
    list.unshift(p);
    try { localStorage.setItem(RKEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
  }
  function renderRecent(scope) {
    var cur = curHandle();
    (scope || document).querySelectorAll('[data-recently-viewed]').forEach(function (grid) {
      var limit = parseInt(grid.getAttribute('data-limit'), 10) || 4;
      var list = readRecent().filter(function (x) { return x && x.handle && x.handle !== cur; }).slice(0, limit);
      var section = grid.closest('[data-recently-viewed-section]');
      if (!list.length) { if (section) section.hidden = true; return; }
      grid.innerHTML = list.map(function (p) {
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        if (root.charAt(root.length - 1) !== '/') root += '/';
        var url = p.url || (root + 'products/' + encodeURIComponent(p.handle));
        // localStorage is same-origin-writable by any embedded script - never
        // emit a stored URL with a scheme (javascript:, data:); allow paths only
        if (!/^\//.test(url) || /^\/\//.test(url)) url = root + 'products/' + encodeURIComponent(p.handle);
        return '<a class="pcard rv-card" href="' + attr(url) + '">' +
          '<div class="pcard-media">' + (p.image ? '<img class="pcard-img" src="' + attr(p.image) + '" alt="" loading="lazy" style="width:100%;height:100%;object-fit:cover">' : '') + '</div>' +
          '<div class="pcard-body"><div class="pcard-name">' + esc(p.title) + '</div>' +
          '<div class="pcard-foot"><div class="pcard-price">' + esc(p.price) + '</div></div></div></a>';
      }).join('');
      var sec = grid.closest('[data-recently-viewed-section]'); if (sec) sec.removeAttribute('hidden');
    });
  }

  /* ---- back to top ---- */
  function initBackTop() {
    if (document.querySelector('.back-top')) return;
    var bt = document.createElement('button');
    bt.type = 'button';
    bt.className = 'back-top';
    bt.setAttribute('aria-label', 'Back to top');
    bt.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg><span>TOP</span>';
    bt.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); });
    document.body.appendChild(bt);
    var ticking = false;
    function onScroll() {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        bt.classList.toggle('show', window.scrollY > 700);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function init(scope) { initAcc(scope); initCompare(scope); renderRecent(scope); }
  function boot() { storeCurrent(); init(document); initBackTop(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
